import clsx from "clsx";
import React from "react";

interface Props {
  onToggle: () => void;
  isOn?: boolean;
  trackClassName?: string;
  thumbClassName?: string;
  checkedThumbClassName?: string;
  // Applied to the track only while checked — lets callers give the ON state a distinct color
  // (the base track color is identical on/off, so position alone reads as ambiguous).
  checkedTrackClassName?: string;
  // "lg" (default) keeps the original size; "md" is a smaller variant (the on-thumb offset is baked per size,
  // so it can't be overridden via className alone).
  size?: "md" | "lg";
}

const SIZES = {
  lg: { track: "w-12 h-4", thumb: "w-7 h-7", on: "translate-x-[20px]" },
  md: { track: "w-10 h-3.5", thumb: "w-6 h-6", on: "translate-x-[16px]" },
};

const ToggleButton = ({ onToggle, isOn, trackClassName, thumbClassName, checkedThumbClassName, checkedTrackClassName, size = "lg" }: Props) => {
  const [isChecked, setIsChecked] = React.useState(isOn);
  const cfg = SIZES[size];

  React.useEffect(() => {
    setIsChecked(isOn);
  }, [isOn]);

  const handleClick = () => {
    setIsChecked((prev) => !prev);
    onToggle();
  };

  return (
    <button className={clsx("relative bg-grey-light border border-border rounded-[9px] cursor-pointer", cfg.track, trackClassName, isChecked && checkedTrackClassName)} onClick={handleClick}>
      <span
        className={clsx("absolute bg-black transition-all top-1/2 -left-[1px] -translate-y-1/2 rounded-full", cfg.thumb, isChecked ? cfg.on : "", isChecked && checkedThumbClassName, thumbClassName)}
      />
    </button>
  );
};

export default ToggleButton;
